import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecoveryState } from './recovery.reducer';

const selectState = createFeatureSelector<RecoveryState>('recovery');

export const selectUserByRecoveryEncryptedId = createSelector(selectState, (state: RecoveryState) => {
  return state.user;
});

export const selectchangePassword = createSelector(
  selectState,
  (state: RecoveryState) => state.isPasswordChanged
);


